import React from "react";

const ChemotherapyContent = {
  checklistText: (
    <React.Fragment>
      <p>
        This benefit is paid for day patient or out-patient chemotherapy you
        receive free under the NHS for the treatment of cancer, and only if the
        treatment would have been eligible under your plan.
      </p>
      <p>
        It is only available for the treatment sessions and not consultation or
        diagnostic appointments.
      </p>
      <p>Before you start, please have the following ready:</p>
    </React.Fragment>
  ),
  checklist: [
    "Invoices, receipts or bills for your claim",
    "Start date of the treatment",
    "Chemotherapy regime – defining the drugs to be used, their dosage, the frequency and duration of treatment(s)",
    "Number and frequency of cycles",
    "Total number of visits for the course"
  ],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them. If your treatment hasn’t yet started, your claim will be assessed once the start date of treatment has been reached.",
  infoBoxIconClass: "icon-help-outline"
};

const Chemotherapy = {
  HOL: {
    ...ChemotherapyContent,
    checklistText: (
      <React.Fragment>
        <p>
          This benefit is paid for day patient or out-patient chemotherapy you
          receive free under the NHS for the treatment of cancer, and only if
          the treatment would have been eligible under your policy.
        </p>
        <p>
          It is only available for the treatment sessions and not consultation
          or diagnostic appointments.
        </p>
        <p>Before you start, please have the following ready:</p>
      </React.Fragment>
    )
  },
  Any: ChemotherapyContent
};

export default Chemotherapy;
